import { z } from 'zod';
import { NotNullStringSchema } from '@/std/schema';

enum RepresentanteTipo {
    Principal = 1,
    Secundario = 2,
}

export const RepresentanteSchema = z.object({
    rep_nome: NotNullStringSchema,
    rep_suporte_email: NotNullStringSchema,
    rep_suporte_link_acesso_remoto: NotNullStringSchema,
    rep_suporte_telefone: NotNullStringSchema,
    rep_suporte_whatsapp: NotNullStringSchema,
    rep_tipo: z.enum(RepresentanteTipo),
});
